export const industryOptions = [
  "Plumbing",
  "HVAC",
  "Roofing",
  "Electrical",
  "Landscaping",
  "Cleaning Services",
  "Legal Services",
  "Dental / Medical",
  "Real Estate",
  "SaaS / Software",
  "Ecommerce",
  "Consulting",
  "Marketing Agency",
  "Fitness / Wellness",
  "Restaurants / Food",
  "Auto Repair",
  "Home Improvement",
  "Financial Services",
  "Education / Tutoring",
  "Other",
];

export const faqItems = [
  {
    question: "What is a value proposition generator?",
    answer:
      "A value proposition generator is a tool that helps you create a clear, compelling statement about why customers should choose your business over competitors. It distills your unique benefits, target audience, and differentiators into ad-ready messaging you can use in Google Ads headlines, descriptions, and landing pages.",
  },
  {
    question: "How does Upfixe generate my value proposition?",
    answer:
      "You enter your business name, industry, target customer, and what makes you different. We use that information to craft a value proposition tailored to your Google Ads campaigns — focusing on the language that drives clicks and conversions for your specific audience.",
  },
  {
    question: "Is the value proposition generator really free?",
    answer:
      "Yes, completely free. Enter your business details, and we'll email you a custom value proposition at no cost. No credit card required, no hidden fees. We also include tips on how to use it in your Google Ads campaigns.",
  },
  {
    question: "How do I use my value proposition in Google Ads?",
    answer:
      "Your value proposition becomes the foundation of your ad copy. Use it in your headline to grab attention, in your description to explain benefits, and on your landing page to reinforce why visitors should convert. A strong value proposition improves your Quality Score and lowers your cost per click.",
  },
  {
    question: "What makes a good value proposition for ads?",
    answer:
      "A strong ad value proposition is specific (not generic), benefit-focused (not feature-focused), addresses a real pain point, and differentiates you from competitors. It should be concise enough for a Google Ads headline (30 characters) while still being compelling.",
  },
  {
    question: "Can I generate multiple value propositions?",
    answer:
      "Absolutely. You can submit the form multiple times with different angles or target audiences. We recommend testing different value propositions in your ad campaigns to see which resonates best with your customers.",
  },
  {
    question: "How is this different from ChatGPT or other AI tools?",
    answer:
      "Generic AI tools give you generic copy. Upfixe is purpose-built for Google Ads — we understand character limits, Quality Score factors, and what actually drives ad performance. Your value proposition is crafted specifically for paid search, not just general marketing.",
  },
  {
    question: "What happens after I submit my details?",
    answer:
      "You'll receive an email with your custom value proposition, along with tips on implementing it in your Google Ads campaigns. We'll also share a few follow-up resources on improving your ad performance — all free, no pressure to buy anything.",
  },
];

export const vpExamples = [
  {
    industry: "Plumbing",
    generic: "We're a plumbing company. Call us today.",
    strong: "24/7 Emergency Plumbing — Fixed-Price Repairs, No Call-Out Fee",
    explanation:
      "Addresses urgency, removes price anxiety, and differentiates with no call-out fee.",
  },
  {
    industry: "SaaS",
    generic: "Our software helps businesses grow.",
    strong: "Cut Reporting Time by 80% — Automated Analytics for Marketing Teams",
    explanation:
      "Quantifies the benefit, names the audience, and highlights automation as the differentiator.",
  },
  {
    industry: "Ecommerce",
    generic: "Shop our great products online.",
    strong: "Handcrafted Skincare Delivered in 48hrs — Free Returns, Always",
    explanation:
      "Specificity (handcrafted, skincare), speed promise (48hrs), and risk removal (free returns).",
  },
  {
    industry: "Local Service",
    generic: "Trusted local business serving the community.",
    strong: "Dallas's #1 Rated House Cleaning — Same-Day Booking, 100% Satisfaction Guarantee",
    explanation:
      "Local proof (#1 rated), convenience (same-day), and risk reversal (guarantee).",
  },
];
